import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import ButtonTable from "../common/table/buttonTable";
import Button from "../common/button/button";
import Form from "./redeForm";
import Select from "../common/form/select";
import { DisplayPDF } from "../displayPDF/displayPDF";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import { getUcValidarUsuarioImplantacao } from "../cliente/clienteActions";
import { adicionarBloqueioUsuarioImplantacao } from "../utils/adicionarBloqueioUsuarioImplantacao";
import {
    setModoTela,
    initForm,
    setFiltro,
    salvar,
    excluir,
    getLista,
    getListaCliente,
    getListaUnidadeConsumidora,
    buscarPdfUnifilarRedeInterna,
    buscarPdfProjetoRedeInterna,
    buscarProjetoRedeInternaGoogleEarth,
    inicializarFormulario,
} from "./redeActions";
import { Loading } from "../common/loading/loading";
import { setError } from "../common/toast/toast";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria";
import { LabelSelectUcIconeGestor } from "../common/form/LabelSelectUcIconeGestor";
import { useEffect } from "react";

function Rede(props) {
    const [state, setState] = useState({
        exibirModalGestorConcessionaria: false,
        itemSelecionado: null,
    });

    //Sem acesso
    if (!props.usuarioLogado || props.usuarioLogado.acesso_cliente) {
        setError("Acesso negado!");
        return <div />;
    }

    useEffect(() => {
        props.getUcValidarUsuarioImplantacao();
        props.getListaCliente();
        props.getListaUnidadeConsumidora();
        props.getLista();
    }, []);

    useEffect(() => {
        props.getLista();
    }, [props.filtro]);

    if (props.pdf) {
        return <DisplayPDF closePdf={() => props.setArquivoPDF()} pdfBase64={props.pdf} nomePdf={props.nomePdf} />;
    }
    return (
        <div>
            {props.aguardando ? <Loading /> : null}

            <Content>
                {props.modoTela === "visualizacao" && <Form onSubmit={() => {}} visualizacao />}
                {props.modoTela === "cadastro" && <Form onSubmit={props.salvar} />}
                {props.modoTela === "exclusao" && <Form excluir onSubmit={props.excluir} />}
                {props.modoTela === "lista" && lista()}
            </Content>
        </div>
    );

    function lista() {
        return (
            <ContentCard>
                <ModalGestorConcessonaria
                    visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_energia}
                    itemSelecionado={state.itemSelecionado}
                    handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
                />
                <ContentCardHeader>
                    <Row>
                        <Grid cols="6 6 4 2">
                            <Button
                                text="Adicionar"
                                type={"success"}
                                icon={"fa fa-plus"}
                                disabled={!props.usuarioLogado.acesso_redes_editar}
                                event={() => {
                                    props.setModoTela("cadastro", {});
                                    props.initForm({});
                                }}
                            />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody>
                    <Row>
                        <Select
                            name="id_cliente"
                            options={props.listaCliente.filter((cliente) => props.lista.find((rede) => rede.id_cliente === cliente.id))}
                            label="Cliente"
                            cols="12 6 4"
                            placeholder="Selecione o Cliente"
                            value={props.filtro.id_cliente}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_cliente: value,
                                    id_unidade_consumidora: null,
                                });
                            }}
                        />
                        <Select
                            name="id_unidade_consumidora"
                            options={props.listaUnidadeConsumidora.filter(
                                (item) =>
                                    ((!props.filtro.id_cliente && props.usuarioLogado && props.usuarioLogado.administrador) || item.id_cliente == props.filtro.id_cliente) &&
                                    props.lista.find((rede) => rede.id_unidade_consumidora === item.id)
                            )}
                            label={
                                <LabelSelectUcIconeGestor
                                    filtro={props.filtro}
                                    listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                                    setExibirModal={(ucFiltro) =>
                                        setState({
                                            ...state,
                                            exibirModalGestorConcessionaria: true,
                                            itemSelecionado: ucFiltro,
                                        })
                                    }
                                />
                            }
                            cols="12 6 4"
                            placeholder="Selecione a UC"
                            value={props.filtro.id_unidade_consumidora}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_unidade_consumidora: value,
                                });
                            }}
                        />
                    </Row>

                    <Table responsive>
                        <THead>
                            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                <Th minWidth={200} sticky>
                                    Cliente
                                </Th>
                                <Th minWidth={200} sticky>
                                    UC
                                </Th>
                                <Th minWidth={100} sticky alignCenter>
                                    Unifilar de Rede Interna PDF
                                </Th>
                                <Th minWidth={100} sticky alignCenter>
                                    Projeto Rede Interna PDF
                                </Th>
                                <Th minWidth={100} sticky alignCenter>
                                    Projeto Rede Interna Google Earth
                                </Th>
                            </NewTr>
                        </THead>
                        <TBody>
                            {props.lista.map((item) => {
                                const numeroUC = `UC-${item.nome_unidade_consumidora.split("-")[0].trim()}`;
                                return (
                                    <NewTr
                                        key={item.id}
                                        backgroundColorTr={"#FFFFFF"}
                                        backgroundColorTd={"#F5F5F5"}
                                        botoes={[
                                            {
                                                type: "primary",
                                                icon: "fas fa-eye",
                                                disabled: !props.usuarioLogado.acesso_redes_visualizar,
                                                event: () => {
                                                    props.inicializarFormulario({
                                                        id: item.id,
                                                        modo: "visualizacao",
                                                    });
                                                },
                                            },
                                            {
                                                type: "warning",
                                                icon: "fas fa-pencil-alt",
                                                disabled: !props.usuarioLogado.acesso_redes_editar || item.bloquearEdicaoUsuarioImplantacao,
                                                event: () => {
                                                    props.inicializarFormulario({ id: item.id, modo: "cadastro" });
                                                },
                                            },
                                            {
                                                type: "danger",
                                                icon: "fas fa-trash-alt",
                                                disabled: !props.usuarioLogado.acesso_redes_editar || item.bloquearEdicaoUsuarioImplantacao,
                                                event: () => {
                                                    props.inicializarFormulario({ id: item.id, modo: "exclusao" });
                                                },
                                            },
                                        ]}
                                    >
                                        <Td>{item.nome_cliente}</Td>
                                        <Td>{item.nome_unidade_consumidora}</Td>
                                        <Td alignCenter minWidth={50}>
                                            <ButtonTable
                                                title="Visualizar"
                                                type={"primary"}
                                                icon={"fas fa-file-pdf"}
                                                visible={!!item.arquivo3}
                                                disabled={!props.usuarioLogado.acesso_redes_visualizar}
                                                event={() => {
                                                    props.buscarPdfUnifilarRedeInterna({
                                                        id: item.id,
                                                        nome: `Mapa_unifilar_rede_interna_${numeroUC}`,
                                                    });
                                                    props.setArquivoPDF();
                                                }}
                                            />
                                        </Td>
                                        <Td alignCenter minWidth={50}>
                                            <ButtonTable
                                                title="Visualizar"
                                                type={"primary"}
                                                icon={"fas fa-file-pdf"}
                                                visible={!!item.arquivo1}
                                                disabled={!props.usuarioLogado.acesso_redes_visualizar}
                                                event={() => {
                                                    props.buscarPdfProjetoRedeInterna({
                                                        id: item.id,
                                                        nome: `Projeto_rede_interna_${numeroUC}`,
                                                    });
                                                    props.setArquivoPDF();
                                                }}
                                            />
                                        </Td>
                                        <Td alignCenter minWidth={50}>
                                            <ButtonTable
                                                title="Baixar"
                                                type={"primary"}
                                                icon={"fas fa-file-pdf"}
                                                visible={!!item.arquivo2}
                                                disabled={!props.usuarioLogado.acesso_redes_visualizar}
                                                event={() => {
                                                    props.buscarProjetoRedeInternaGoogleEarth({
                                                        id: item.id,
                                                        nome: `Google_earth_projeto_rede_interna_${numeroUC}`,
                                                    });
                                                }}
                                            />
                                        </Td>
                                    </NewTr>
                                );
                            })}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }
}

const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.rede.modoTela,
    formularioValues: getFormValues("redeForm")(state),
    aguardando: state.rede.aguardando,
    filtro: state.rede.filtro,
    lista: adicionarBloqueioUsuarioImplantacao(state.auth.usuarioLogado, state.cliente.listaUcValidarUsuarioImplantacao, state.rede.lista),
    listaCliente: state.rede.listaCliente,
    listaUnidadeConsumidora: state.rede.listaUnidadeConsumidora,
    listaMeses: state.rede.listaMeses,
    pdf: state.displayPDF.pdf,
    nomePdf: state.displayPDF.nomePdf,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            setArquivoPDF,
            initForm,
            setFiltro,
            salvar,
            excluir,
            getLista,
            getListaCliente,
            getListaUnidadeConsumidora,
            getUcValidarUsuarioImplantacao,
            buscarPdfUnifilarRedeInterna,
            buscarPdfProjetoRedeInterna,
            buscarProjetoRedeInternaGoogleEarth,
            inicializarFormulario,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(Rede);
